import React from 'react';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';

import { hasPhotoLikeComponent } from '../../utils/util';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';
import NormalButton from './NormalButton';

const ImageShareButton = () => {
  const activeGallery = activeGalleryInstance.get();
  const hasPhotoData = activeGallery
    ? activeGallery.total !== 0 ||
      activeGallery.list.length > 0 ||
      activeGallery.hotList.length > 0 ||
      activeGallery.personList.length > 0
    : false;

  if (
    !hasPhotoLikeComponent(window.pageDetail.template || []) ||
    !activeGallery ||
    (activeGallery.total === 0 && !hasPhotoData)
  ) {
    return null;
  }

  const startImageShare = () => {
    const visibleEvent = new Event('PENDENT_FOLD');
    visibleEvent.data = 1;
    window.dispatchEvent(visibleEvent);
    activeGallery.setJigsaw({
      type: 'share',
      bottomShow: true,
      jigsawList: [],
    });
  };

  return (
    <NormalButton onClick={startImageShare}>
      {intl.get('ChooseShare')}
    </NormalButton>
  );
};

export default inject('rootStore')(observer(ImageShareButton));
